


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ProductForm from './ProductForm';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ProductDetails from './ProductDetails';


const ProductList = () => {
    const [products, setProducts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [selectedProductData, setSelectedProductData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [setupIdError, setSetupIdError] = useState('');
    const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
    const [brands, setBrands] = useState({ allBrands: [] });
    const [vendors, setVendors] = useState({ allVendors: [] });

    const [errors, setErrors] = useState({});

    const WithCreatePermission = withPermission(({ children }) => children, ['product-create']);
    const WithEditPermission = withPermission(({ children }) => children, ['product-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['product-delete']);

    const didFetchRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchProducts(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };
    const fetchProducts = async (page = 1, search = searchQuery) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/products`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search,
                },
            });

            const resData = response.data?.Data || response.data || {};
            const items = Array.isArray(resData.data) ? resData.data : (Array.isArray(resData) ? resData : []);

            setProducts(items);
            setCurrentPage((resData.current_page || 1) - 1);
            setPageCount(resData.last_page || 1);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const fetchCategories = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allCategories = [];

            const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allCategories = [...allCategories, ...response.data.category];

            const allCategoriesList = allCategories.filter(cat => !cat.parent_id);

            // All subcategories (categories with parent_id)
            const allSubcategories = allCategories.filter(cat => cat.parent_id);

            setCategories({ allCategoriesList, allSubcategories });
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    const fetchBrands = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allBrands = [];



            const response = await axios.get(`${backendUrl}/api/brands`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allBrands = [...allBrands, ...response.data.brand];


            setBrands({ allBrands });
        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };
    const fetchVendors = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            let allVendors = [];

            const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                skipLoader: true,

            });

            // const { data, current_page, last_page } = response.data.Data;
            allVendors = [...allVendors, ...response.data.Data];

            setVendors({ allVendors });

        } catch (error) {
            console.error(`Error fetching vendors:`, error);
        }
    };
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
    });

    const handleExport = async () => {
        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products/export`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, "products.xlsx");

            Toast.fire({
                icon: "success",
                title: "Products exported successfully!",
            });
        } catch (error) {
            console.error("Export error:", error);
            Toast.fire({
                icon: "error",
                title: "Export failed! Please try again.",
            });
        }
    };

    const handleImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/products/import`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            Toast.fire({
                icon: "success",
                title: "Products imported successfully!",
            });
            setTimeout(() => window.location.reload(), 1000);

            e.target.value = "";
        } catch (error) {
    console.error("Import error:", error);

    let message = "Import failed! Please check your file.";

    if (error.response?.status === 422) {
        // Laravel ValidationException structure
        if (error.response.data?.errors) {
            const err = error.response.data.errors;
            if (Array.isArray(err.message)) {
                message = err.message[0];
            } else {
                message = Object.values(err)[0][0];
            }
        }
    } else if (error.response?.data?.message) {
        message = error.response.data.error || error.response.data.message;
    }

    Toast.fire({
        icon: "warning",
        title: message,
    });

    e.target.value = "";
}

    };
    const addProduct = async (newProduct) => {
        try {
            const formData = new FormData();

            Object.entries(newProduct).forEach(([key, value]) => {
                if (key === "category_id" && Array.isArray(value)) {
                    value.forEach((id, i) => {
                        formData.append(`category_id[${i}]`, id);
                    });
                }
                else if (key === "pricings" && Array.isArray(value)) {
                    value.forEach((p, i) => {
                        formData.append(`pricings[${i}][license_model]`, p.license_model);
                        formData.append(`pricings[${i}][price]`, p.price ?? "");
                        formData.append(`pricings[${i}][deployment_cost]`, p.deployment_cost ?? "");
                        formData.append(`pricings[${i}][min_price]`, p.min_price ?? "");
                        formData.append(`pricings[${i}][deployment_description]`, p.deployment_description ?? "");
                        formData.append(`pricings[${i}][is_default_channel]`, p.is_default_channel ? "1" : "0");
                    });
                }
                else if (key === "product_image" && value) {
                    formData.append("product_image", value);
                }
                else {
                    formData.append(key, value);
                }
            });

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/products`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                    "Tenant-Origin": origin,
                },
            });

            const createdProduct = response.data.Data || response.data.product;
            if (createdProduct) {
                setProducts((prev) => [...prev, createdProduct]);
            } else {
                console.error("Creation failed, no data returned.");
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error("Error adding product:", error);
            }
        }
    };

    const editProduct = async (productId, updatedData) => {
        try {
            const formData = new FormData();

            Object.entries(updatedData).forEach(([key, value]) => {
                if (key === "category_id" && Array.isArray(value)) {
                    value.forEach((id, i) => {
                        formData.append(`category_id[${i}]`, id);
                    });
                }
                else if (key === "pricings" && Array.isArray(value)) {
                    value.forEach((p, i) => {
                        formData.append(`pricings[${i}][license_model]`, p.license_model);
                        formData.append(`pricings[${i}][price]`, p.price ?? "");
                        formData.append(`pricings[${i}][deployment_cost]`, p.deployment_cost ?? "");
                        formData.append(`pricings[${i}][min_price]`, p.min_price ?? "");
                        formData.append(`pricings[${i}][deployment_description]`, p.deployment_description ?? "");
                        formData.append(`pricings[${i}][is_default_channel]`, p.is_default_channel ? "1" : "0");
                    });
                }
                else if (key === "product_image" && value) {
                    formData.append("product_image", value);
                }
                else {
                    formData.append(key, value);
                }
            });

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/products/${productId}?_method=PUT`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const updatedProduct = response.data.product || response.data.Data;

            if (updatedProduct) {
                setProducts((prevProducts) =>
                    prevProducts.map((product) => (product.id === updatedProduct.id ? updatedProduct : product))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error('Error updating product:', error);
            }
        }
    };


    const deleteProduct = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;

                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    await axios.delete(`${backendUrl}/api/products/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });

                    setProducts(products.filter(product => product.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The product has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting product:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete product. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (productId = null) => {

        if (productId) {
            const productToEdit = products.find(product => product.id === productId);
            if (productToEdit) {
                setSelectedProductData(productToEdit);
            }
        } else {
            setSelectedProductData(null);
        }
        setSelectedProductId(productId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedProductId(null);
        setSelectedProductData(null);
        setSetupIdError('');
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchProducts(selectedPage);
    };

    const truncateDescription = (description, maxLength = 50) => {
        if (!description) return '-';
        if (description.length <= maxLength) return description;
        return description.substring(0, maxLength) + '...';
    };

    const [showLeadOffcanvas, setShowLeadOffcanvas] = useState(false);

    const handleShowLeadDetails = (leadId) => {
        setSelectedProductId(leadId);
        setShowLeadOffcanvas(true);
    };

    const handleCloseLeadDetails = () => {
        setShowLeadOffcanvas(false);
        setSelectedProductId(null);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Products</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        {/* <li className="breadcrumb-item"><a href="/">Dashboard</a></li> */}
                                        {/* <li className="breadcrumb-item active">Product List</li> */}
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Product Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>

                                        {/* <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={() => handleShowModal()} data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Add Product"
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button>
                                        </WithCreatePermission> */}
                                        <div className="d-flex align-items-center gap-2">
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export to Excel"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import from Excel"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>

                                            <WithCreatePermission>
                                                <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                    onClick={() => handleShowModal()}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add Product"
                                                >
                                                    <i className="mdi mdi-plus"></i>
                                                </button>
                                            </WithCreatePermission>
                                        </div>

                                    </div>
                                    {/* Table */}
                                    <div>
                                        <div className="table-responsive">
                                            <table className="table table-compact align-middle table-check table-list">
                                                <thead className="table-sales-gradient">
                                                    <tr>
                                                        <th className="align-middle text-center" style={{ width: '40px' }}>
                                                            <div className="form-check font-size-16 m-0">
                                                                <input className="form-check-input" type="checkbox" id="checkAll" />
                                                                <label className="form-check-label" htmlFor="checkAll"></label>
                                                            </div>
                                                        </th>
                                                        <th style={{ width: '50px' }}>#</th>
                                                        <th style={{ width: '150px' }}>Brand</th>
                                                        <th style={{ width: '200px' }} >Product Name</th>
                                                        <th style={{ width: '300px' }}>Description</th>
                                                        <th style={{ width: '150px' }}>Category</th>
                                                        <th style={{ width: '80px' }}>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {products.length > 0 ? (
                                                        products.map((product, index) => (
                                                            <tr key={product.id}>
                                                                <td className="text-center">
                                                                    <div className="form-check font-size-16 m-0">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`productCheck${index}`}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor={`productCheck${index}`}
                                                                        ></label>
                                                                    </div>
                                                                </td>

                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <button
                                                                        onClick={() => handleShowLeadDetails(product.id)} // Pass lead ID
                                                                        className="dropdown-item"
                                                                    >
                                                                        {product.brand?.name || '-'}
                                                                    </button>
                                                                </td>

                                                                <td
                                                                    title={product.product_name}
                                                                    style={{
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        maxWidth: '200px',
                                                                    }}
                                                                >
                                                                    <Link
                                                                        to={`/product/details/${product.id}`}
                                                                        className="text-decoration-none text-dark"
                                                                    >
                                                                        {product.product_name}
                                                                    </Link>
                                                                </td>

                                                                <td
                                                                    className="text-start"
                                                                    title={product.description}
                                                                    style={{
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        maxWidth: '300px',
                                                                    }}
                                                                >
                                                                    {truncateDescription(product.description, 80)}
                                                                </td>

                                                                <td>{product.license_type || '-'}</td>

                                                                <td className="text-center">
                                                                    <div className="dropdown">
                                                                        <i
                                                                            className="mdi mdi-dots-horizontal font-size-18"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                            style={{ cursor: 'pointer' }}
                                                                        ></i>
                                                                        <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                            <li>
                                                                                <button
                                                                                    onClick={() => handleShowLeadDetails(product.id)} // Pass lead ID
                                                                                    className="dropdown-item"
                                                                                >
                                                                                    View Details
                                                                                </button>
                                                                            </li>
                                                                            <li>
                                                                                <WithEditPermission>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => handleShowModal(product.id)}
                                                                                    >
                                                                                        Edit
                                                                                    </button>
                                                                                </WithEditPermission>
                                                                            </li>
                                                                            <li>
                                                                                <WithDeletePermission>
                                                                                    <button
                                                                                        className="dropdown-item"
                                                                                        onClick={() => deleteProduct(product.id)}
                                                                                    >
                                                                                        Delete
                                                                                    </button>
                                                                                </WithDeletePermission>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center py-3">
                                                                No products found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* <table className="table  align-middle table-nowrap table-check table-list">
                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th  className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle" >#</th>
                                                    <th className="align-middle">Brand</th>
                                                    <th className="align-middle ">Product Name</th>
                                                    <th className="align-middle text-start">Description</th>

                                                    <th className="align-middle" >Category</th>
                                                    <th className="align-middle" >Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {products.length > 0 ? (
                                                    products.map((product, index) => (
                                                        <tr key={product.id}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`productCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`productCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td >{index + 1}</td>
                                                            <td>{product.brand?.name || '-'}</td>
                                                            <td
                                                               
                                                                title={product.product_name}
                                                            >
                                                                <Link to={`/product/details/${product.id}`} className="dropdown-item">
                                                                    {product.product_name}
                                                                </Link>
                                                            </td>

                                                            <td className='text-start'
                                                                
                                                                title={product.description}
                                                            >
                                                                {truncateDescription(product.description, 80)}
                                                            </td>


                                                            <td >{product.license_type || '-'}</td>
                                                            <td >
                                                                <div className="dropdown">
                                                                    <i
                                                                        className="mdi mdi-dots-horizontal font-size-18"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                        style={{ cursor: 'pointer' }}
                                                                    ></i>
                                                                    <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                        <li>
                                                                            <Link to={`/product/details/${product.id}`} className="dropdown-item">
                                                                                View Details
                                                                            </Link>
                                                                        </li>
                                                                        <li>
                                                                            <WithEditPermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleShowModal(product.id)}
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            </WithEditPermission>
                                                                        </li>
                                                                        <li>
                                                                            <WithDeletePermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => deleteProduct(product.id)}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                            </WithDeletePermission>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center py-3">No products found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> */}
                                        {/* <div className="d-flex justify-content-between align-items-center mt-3">
                                            <span style={{fontSize:'12px',color:'#6e6e6e'}}>Showing 1 to 10 of {products.length} entries</span> */}
                                        <div className="d-flex justify-content-end pagination-sm">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                pageCount={pageCount}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={3}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                previousClassName={'page-item previous'}
                                                previousLinkClassName={'page-link'}
                                                nextClassName={'page-item next'}
                                                nextLinkClassName={'page-link'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ProductForm
                        key={selectedProductId || 'new'}
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        productId={selectedProductId}
                        productData={selectedProductData}
                        addProduct={addProduct}
                        editProduct={editProduct}
                        products={products}
                        setupIdError={setupIdError}
                        categories={categories}
                        fetchCategories={fetchCategories}
                        errors={errors}
                        setErrors={setErrors}
                        fetchBrands={fetchBrands}
                        brands={brands}
                        vendors={vendors}
                        fetchVendors={fetchVendors}




                    />
                      <ProductDetails
                        show={showLeadOffcanvas}
                        onHide={handleCloseLeadDetails}
                        productId={selectedProductId}
                    // onOrganisationUpdate={fetchOrganisation} // Pass refresh function if needed
                    />
                </div>
            </div>
        </div>
    );
};

export default ProductList;







